import { render, staticRenderFns } from "./SetZoneModal.vue?vue&type=template&id=255ffee8&scoped=true&"
import script from "./SetZoneModal.vue?vue&type=script&lang=js&"
export * from "./SetZoneModal.vue?vue&type=script&lang=js&"
import style0 from "./SetZoneModal.vue?vue&type=style&index=0&id=255ffee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255ffee8",
  null
  
)

export default component.exports